import NextLink from 'next/link';
import PropTypes from 'prop-types';

import { noop } from 'lib/utils';

import PaginationButton from './Button';

const PaginationLinkButton = ({
  href = null,
  onClick = noop,
  children,
  ...rest
}) => {
  if (href) {
    return (
      <NextLink href={href} prefetch={false} passHref>
        <PaginationButton as="a" onClick={onClick} {...rest}>
          {children}
        </PaginationButton>
      </NextLink>
    );
  }

  return (
    <PaginationButton onClick={onClick} {...rest}>
      {children}
    </PaginationButton>
  );
};

PaginationLinkButton.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
};

export default PaginationLinkButton;
